// Shared formatting for the explain-trace components. Candidate scores arrive
// as raw floats; the headline trace.score is already a string.
export const fmt = (value) => {
  if (typeof value === "number") return value.toFixed(4);
  if (value === null || value === undefined) return "—";
  return value;
};
